<template>
<div class="content-body tenant-settings">
    <div class="">
        <!-- 技术通知类型 不同类型的模板 需要提供：QA -->
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <el-form-item label="项目编码:">
                <el-input size="small" v-model="dataForm.code" placeholder="项目编码" clearable @blur="getDataList" class="input-width"></el-input>
            </el-form-item>
            <el-form-item label="项目名称:">
                <el-input size="small" v-model="dataForm.name" placeholder="项目名称" clearable @blur="getDataList" class="input-width"></el-input>
            </el-form-item>
            <el-form-item label="技术通知名称:">
                <el-input size="small" v-model="dataForm.technicalName" placeholder="技术通知名称" clearable @blur="getDataList" class="input-width"></el-input>
            </el-form-item>
            <el-form-item label="车型:">
                <el-input size="small" v-model="dataForm.type" placeholder="车型" clearable @blur="getDataList" class="input-width"></el-input>
            </el-form-item><br>
            <el-form-item label="类型:" label-width="71px">
                <el-select size="small" v-model="dataForm.technicalType" placeholder="请选择类型" clearable @change="getDataList" class="input-width">
                    <el-option v-for="item in TECHNICAL_NOTIFICATION_TYPE" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态:" label-width="71px">
                <!-- <el-select size="small" v-model="dataForm.technicalStatus" placeholder="请选择状态" clearable @change="getDataList" class="input-width">
                    <el-option v-for="item in TECHNICAL_INFO_STATUS" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select> -->
                <el-cascader class="input-width" v-model="technicalStatuses" :options="TECHNICAL_INFO_STATUS" :props="{ multiple: true, checkStrictly: true }" collapse-tags clearable></el-cascader>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="getDataList()" icon="el-icon-search" style="margin-left:10px">
                    查询
                </el-button>
                <el-button size="small" v-if="isAuth('sourcing:requirement:newbutton')" type="primary" plain @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建
                </el-button>
                <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-s-promotion">
                    发布
                </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" bProject style="width: 100%" :default-expand-all="false" border :header-cell-style="{ background: '#f5f5f5' }" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="technicalCode" header-align="center" align="left" label="技术通知编码" width="160">
                </el-table-column>
                <el-table-column prop="technicalName" header-align="center" align="left" label="技术通知名称">
                </el-table-column>
                <el-table-column prop="projectCode" header-align="center" align="left" label="项目编码" width="160">
                </el-table-column>
                <!-- <el-table-column prop="projectName" header-align="center" align="left" label="项目名称">
                </el-table-column> -->
                <el-table-column prop="technicalType" header-align="center" align="center" label="类型" width="150">
                    <template slot-scope="scope">
                        <span>
                            {{ typeFormat(scope.row.technicalType) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="carType" header-align="center" align="left" label="车型" width="150">
                </el-table-column>
                <!-- <el-table-column prop="partCount" header-align="center" align="right" label="零件数" width="120">
                </el-table-column> -->
                <!-- <el-table-column prop="issueTime" header-align="center" align="right" label="发布时间" :formatter="dateFormat" width="170">
                </el-table-column> -->
                <el-table-column prop="technicalStatus" class="status" header-align="center" align="center" label="状态" width="80">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.technicalStatus)">{{statusFormat(scope.row.technicalStatus)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" header-align="center" align="right" label="创建时间" :formatter="dateFormat" width="170">
                </el-table-column>
                <el-table-column header-align="center" align="left" min-width="130" label="操作" width="185">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button :disabled="scope.row.technicalStatus == 1" type="text" size="small" @click="addOrUpdateHandle(scope.row)"  icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button :disabled="scope.row.technicalStatus == 1" type="text" size="small" @click="addOrUpdateHandleConfirm(scope.row)"  icon="el-icon-edit">
                            确认
                        </el-button>
                        <!-- TODO -->
                        <!-- <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" :disabled="judgeTechnicalStatus(scope.row.technicalStatus)" :class="{'button-danger': isActive}">
                            删除
                        </el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    fetchTechList,
    deleteTech
} from "@/controller/tech";
import {
    getLabelByValue,
    TECHNICAL_INFO_STATUS,
    TECHNICAL_NOTIFICATION_TYPE,
} from "@/utils/const";
import AddOrUpdate from "./tech-add-or-update";
import moment from "moment";
// require('@/mock/mockTech');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement["clientHeight"] - 250,
            dataForm: {
                code: "",
                name: "",
                technicalName: "",
                type: "",
                technicalStatus: "",
                technicalType: "",
                partCount: "",
                issueTime: "",
                createTime: "",
                technicalStatuses: []
            },
            technicalStatuses: [
                [0],
                [5]
            ],
            TECHNICAL_INFO_STATUS: TECHNICAL_INFO_STATUS,
            TECHNICAL_NOTIFICATION_TYPE: TECHNICAL_NOTIFICATION_TYPE,
            getLabelByValue: getLabelByValue,
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,

        };
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 270;
            },
        },
    },
    components: {
        AddOrUpdate,
    },
    mounted() {
        // this.dataForm="";
        this.getDataList();
    },
    methods: {
        //判断技术通知管理状态
        judgeTechnicalStatus(val) {
            if (val === '0' || val === '5') {
                this.isActive = true
                return false
            } else {
                this.isActive = false
                return true
            }
        },
        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss");
        },
        statusFormat: function (value) {
            if (!value) {
                return "";
            }
            return getLabelByValue(TECHNICAL_INFO_STATUS, value);
        },
        typeFormat: function (value) {
            // debugger;
            if (!value) {
                return "";
            }
            return getLabelByValue(TECHNICAL_NOTIFICATION_TYPE, value);
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true;
            this.dataForm.technicalStatuses = []
            this.technicalStatuses.forEach(status => {
                this.dataForm.technicalStatuses.push(status[0])
            })
            fetchTechList({
                    pageNo: this.pageIndex,
                    pageSize: this.pageSize,
                    projectCode: this.dataForm.code,
                    projectName: this.dataForm.name,
                    technicalName: this.dataForm.technicalName,
                    carType: this.dataForm.type,
                    technicalType: this.dataForm.technicalType,
                    technicalStatus: this.dataForm.technicalStatus,
                    partCount: this.dataForm.partCount,
                    issueTime: this.dataForm.issueTime,
                    createTime: this.dataForm.createTime,
                    technicalStatuses: this.dataForm.technicalStatuses,
                })
                .then((data) => {
                    // console.log(data, 'data')
                    if (data && data.code === "00") {
                        this.dataList = data.body.records;
                        this.totalPage = data.body.total;
                    } else {
                        this.dataList = [];
                        this.totalPage = 0;
                    }
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    this.dataListLoading = false;
                });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        // 查看
        viewHandle(row) {
            // addOrUpdateHandle(row) {
            // console.log(row);
            this.addOrUpdateVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, "view");
            });
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            // addOrUpdateHandle(row) {
            // console.log(row);
            this.addOrUpdateVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, "edit");
            });
        },
        // 确认
        addOrUpdateHandleConfirm(row) {
            // addOrUpdateHandle(row) {
            // console.log(row);
            this.addOrUpdateVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, "view", "confirm");
            });
        },
        // row,
        // row ? row.id : null,
        // 0,
        // null,
        // null,
        // null

        // 删除
        deleteHandle(id) {
            console.log(id);

            let ids = id ? [id] :
                this.dataListSelections.map((item) => {
                    return item.id;
                });

            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    deleteTech(ids)
                        .then((data) => {
                            // deleteTech([id]).then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.getDataList();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {});
        },
        getStatusClass(status) {
            let className = "";
            switch (status) {
                case "0":
                    className = "text-primary";
                    break;
                case "5":
                    className = "text-danger";
                    break;
                default:
                    className = "text-success";
                    break;
            }
            return className;
        },
    },
};
</script>

<style lang="scss" scoped>
.input-width {
    width: 155px;
}
</style>
